import { useEffect } from 'react';

export const useScript = ({
  async, onload, defer, src, scriptContent, callback
}) => {
  useEffect(() => {
    const script = document.createElement('script');

    const urlParams = new URL(src).searchParams;

    script.src = src;

    if (onload) {
      script.onload = () => onload(script);
    }
    if (async) {
      script.async = async;
    }
    if (defer) {
      script.defer = defer;
    }
    if (scriptContent) {
      const scriptText = document.createTextNode(scriptContent);
      script.appendChild(scriptText);
    }
    script.onerror = (errorMsg) => {
      // eslint-disable-next-line no-console
      console.log(`Error occurred during script load - error: ${errorMsg}`);
    };

    if (urlParams?.has('callback')) {
      window[urlParams.get('callback')] = () => callback();
    }

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [src]);
};
